<template>
    <div class="row">
        <div class="col-12 mx-auto">
            <div class="bg-card rounded border-0">
                <div class="card-body p-0" :class="{ 'pt-5': Object.keys(rows).length === 0 }">
                    <div class="table-responsive" v-if="Object.keys(rows).length > 0">
                        <table class="table table-hover table-nowrap">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Client') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Employee') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Job') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Starts At') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Ends At') }}
                                </th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="row in rows">
                                <td>
                                    <strong>{{ row.client }}</strong><br/>
                                    {{ row.location }}
                                </td>
                                <td>{{ row.employee }}</td>
                                <td>
                                    <strong>{{ row.job.title }}</strong>
                                </td>
                                <td v-html="row.job.start_human"></td>
                                <td v-html="row.job.end_human"></td>
                                <td class="text-end">
                                    <div class="btn-group">
                                        <button type="button" v-for="action in row.actions" class="btn btn-sm btn-neutral" :class="action.classes" @click="handleAction(row, action)" :ref="`${row.id}-${action.id}`">
                                            {{ action.label }}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center pb-5" v-else-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <div class="text-center pb-5" v-else>
                        <em>{{ $trans.get('__JSON__.No records found to show') }}</em>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MutationCorrectionModal :user="user" :enrollment="enrollment" type="resolve" ref="resolve" v-if="enrollment" />
</template>

<script>
import MutationCorrectionModal from '@/components/shared/MutationCorrectionModal'
import ModalHelper from './mixins/ModalHelper'

export default {
    name: 'EnrollmentConflicts',
    components: { MutationCorrectionModal },
    mixins: [ModalHelper],
    data() {
        return {
            loading: false,
            enrollment: null,
            user: null,
            rows: [],
        }
    },
    methods: {
        retrieveRows() {
            this.loading = true
            axios.get('/api/hours/conflict')
                .then(response => {
                    const data = response.data
                    this.rows = data.rows
                    this.user = data.user
                })
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.loading = false)
        },
        handleAction(enrollment, action) {
            this.enrollment = enrollment
            if (action.id === 'resolve') setTimeout(async () => this.openModal('resolve_modal'), 50)
        },
        performAction(action, data = {}) {
            if (action === 'resolve') {
                const resolve = this.$refs.resolve,
                    button = resolve.$refs.submit

                return this.makeRequest('resolve', button, data, async () => {
                    await this.closeModal('resolve_modal')
                    this.retrieveRows()
                })
            }
        },
        makeRequest(action, button, context = {}, closure = () => {}) {
            let data = {
                action,
                enrollment: this.enrollment.id,
            }

            const buttonText = button.innerHTML
            button.setAttribute('disabled', true)
            button.innerHTML = '<div class="spinner-border spinner-border-sm text-primary" role="status"></div>'

            return axios.post('/api/hours/conflict', Object.assign(data, context))
                .then(response => closure(response))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => {
                    button.innerHTML = buttonText
                    button.removeAttribute('disabled')
                })
        },
    },
    mounted() {
        this.retrieveRows()
    },
}
</script>
